import React, { useEffect } from 'react';

const AnnouncementModal = ({ announcement, onClose }) => {

   useEffect(() => {
    // Lock scroll
    document.body.style.overflow = 'hidden';
    return () => {
      // Restore scroll when modal closes
      document.body.style.overflow = 'auto';
    };
  }, []);
  if (!announcement) return null;

  const {
  heading,
  subheading,
  paragraph,
  bulletPoints,
  imageUrl
} = announcement;

  const defaultImage = '/WYCOUGHAnnoun.Modal.png';
  const displayImage = imageUrl || defaultImage;

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-start px-4 py-10"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)', 
      }}
>      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] min-h-[60vh] overflow-y-auto relative">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 flex items-center justify-center w-9 h-9 rounded-full bg-white/90 shadow-lg text-gray-700 hover:bg-gray-200 hover:text-black text-2xl font-bold transition"
        >
          &times;
        </button>

        {/* Image */}
        <div className="w-full h-auto">
        <img 
          src={displayImage}
          alt="Announcement"
          className="w-full h-auto object-cover"
          style={{ maxHeight: '300px', objectFit: 'cover' }}
        />
      </div>
      
        {/* Content */}
        <div className="p-6">
          {heading && <h2 className="text-2xl font-bold text-gray-800 mb-2">{heading}</h2>}
          {subheading && <h3 className="text-lg text-gray-600 mb-4">{subheading}</h3>}
          {paragraph && <p className="text-gray-700 mb-4 whitespace-pre-line">{paragraph}</p>}

          {bulletPoints && bulletPoints.length > 0 && (
            <ul className="list-disc list-inside text-gray-700 space-y-1 mb-4">
              {bulletPoints.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;
